/**
 * ユーザ階層管理取得条件VO
 *
 * @export GetUserClassManagementModel
 * @class GetUserClassManagementModel
 */
export class GetUserClassManagementModel {
  // 部門コード
  public ClassCode = String('');
}
